import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/17/thumb-landscape.jpg"

const Post17 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">FENDI／バイザウェイミディアム／27 x17 x13cm</span>      
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          「シーンやスタイル問わず使えるバッグがいい！」<br></br>そんなあなたにオススメしたいのが、フェンディのバッグ。<br></br>1つのバッグでオン･オフ使えたら便利ですよね。そんな素敵なバッグを借りられるのもラクサスの魅力♪ご紹介するフェンディのバッグはシンプルで使いやすく季節も問いません。あらゆるコーデと相性がいい、何にでも合う魔法のバッグがあれば、きっといつものコーデも楽しくなり、新しいスタイルにだって挑戦もできちゃうかも＾＾<br></br>ではそんなフェンディのバッグをのぞいてみましょう♪
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>シンプルで使いやすい♪トゥージュール</h2>
          <p>かっちりしたフォルムが洗練された女性を演出してくれます。落ち着いた色味のものは、お仕事スタイルと相性抜群です♪また、カジュアルなスタイルに合わせれば手抜き感ゼロに早変わりです！</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/17/1.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/17/2.jpg" alt="" />
            </figure>        
        </div>
        <span className="text-center">FENDI／プチトゥージュール／25 x20 x11cm</span>   
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/17/3.jpg" alt="" />
            <span className="text-center">FENDI／プチトゥージュール／26 x20 x11cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/17/4.jpg" alt="" />
            <span className="text-center">FENDI／プチトゥージュール／26 x21 x12cm</span> 
          </figure>          
        </div> 
        <Link to="https://laxus.co/app/pc/bags/fendi" className="view-all-button">
          フェンディのバッグを見る
        </Link>          
        <div className="text-max-width">
          <h2>変幻自在のバイザウェイ</h2>
          <p>魅力はなんと言ってもこれひとつで３通りの楽しみ方ができること♪シーンやスタイルに合わせてハンドバッグ・ショルダー・クラッチと形を変えてくれます。</p>
        </div>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/17/5.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/17/6.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">FENDI／バイザウェイミディアム／27 x18 x13cm</span>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/17/7.jpg" alt="" />
            <span className="text-center">FENDI／バイザウェイミディアム／27 x18 x12cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/17/8.jpg" alt="" />
            <span className="text-center">FENDI／バイザウェイミディアム／27 x18 x13cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>クラッチバッグ内蔵のドットコム♡</h2>
          <p>普段はクールな収納力の優れたバッグとして、内蔵されているクラッチバッグを外せばパーティースタイルにもマッチ。シーンによって使い分けられる便利なバッグです♪</p>
        </div>       
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/17/9.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/17/10.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">FENDI／ドットコム／29 x21 x13cm</span>  
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/17/11.jpg" alt="" />
            <span className="text-center">FENDI／ドットコム／30 x21 x13cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/17/12.jpg" alt="" />
            <span className="text-center">FENDI／ドットコム／23 x17 x10cm</span> 
          </figure>
        </div>           
        <div className="text-max-width">
          <h2>センスが光るトロワジュール</h2>
          <p>かっちりフォルムのバッグがキリリとかっこよくコーデを締めてくれます。パンツスタイルならクールに、スカートと合わせればコーデが甘くなりすぎず上品な印象に♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/17/13.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/17/14.jpg" alt="" />
          </figure>
        </div>     
        <span className="text-center">FENDI／トロワジュール／30 x26 x12cm</span>       
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/17/15.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/17/16.jpg" alt="" />
          </figure>
        </div> 
        <span className="text-center">FENDI／プチトロワジュール／21 x17 x10cm</span>                                                
        <div className="text-two-cloumn">
          <h2>ラクサスで永遠の定番アイテムを見つけてみませんか？</h2>
          <p>「これさえあれば安心！」<br></br>そんなバッグが手元にあったら、とても心強いですよね！１つのバッグで、いろんなシーン、いろんなスタイルに合わせられたら…なんだかワクワクしてきませんか？ラクサスで永遠の定番バッグをレンタルして、おしゃれをもっと楽しみましょう！</p>
        </div>                                     
        <Link to="https://laxus.co/app/pc/bags/fendi" className="view-all-button">
          フェンディのバッグを見る
        </Link>                                                   
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post17

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 17}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
